"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwMonitor = void 0;
var Conviva = require("@convivainc/conviva-js-coresdk");
var object_1 = require("../utils/object");
var constants_1 = require("../constants");
var Base_1 = require("../Base");
var EventLog_1 = require("./EventLog");
var Tealium_1 = require("../Tealium");
var ConvivaMonitor_1 = require("./ConvivaMonitor");
function round(value, precision) {
    if (precision === void 0) { precision = 1; }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
var JwMonitor = /** @class */ (function (_super) {
    __extends(JwMonitor, _super);
    function JwMonitor() {
        var _this = _super.call(this) || this;
        _this.instance = null;
        _this.state = {
            ad: {
                breakCount: 0,
                event: null,
                paused: false,
                position: 0,
            },
            video: {
                started: false,
                scrubbing: false,
                volume: 100,
                position: 0,
                bufferPercent: 0,
            },
            attemptPlay: false,
            completeSent: false,
            visualQuality: null,
        };
        _this.debug = true;
        _this.subscribedEvents = {};
        _this.loadMediaSent = false;
        _this.conviva = null;
        _this.useAdobeDelay = false;
        _this.setPlayReason = function (reason) {
            _this.playReason = reason;
            _this.state.attemptPlay = reason === "interaction";
        };
        _this.init = function (options) {
            if (!options) {
                return _this.error("options need to be provided");
            }
            if (!window.utag) {
                _this.warn("utag needs to be loaded in order to use JwMonitor library");
            }
            _this.options = options;
            if (options === null || options === void 0 ? void 0 : options.convivaConfig) {
                if (_this.conviva) {
                    _this.info("Reuse previous Conviva session");
                    _this.conviva.reportPlaybackEnded();
                }
                else {
                    _this.info("New Conviva session");
                    _this.conviva = new ConvivaMonitor_1.default(_this, options.convivaConfig);
                }
            }
            _this.useAdobeDelay = options.useAdobeDelay || false;
            if (_this.options.debug) {
                _this.events.all = _this.onAll;
            }
            _this.setupInstance(options.id);
        };
        _this.setupInstance = function (playerId) {
            if (_this.instance) {
                _this.unsubscribeToEvents();
                // Todo: send stop event only when needed
                if (_this.loadMediaSent) {
                    try {
                        _this.sendEvent({
                            event_label: "stop",
                            event_action: "stop",
                        });
                    }
                    catch (error) {
                        _this.info("use event values from previous video event");
                        var lastEvent = EventLog_1.default.getLastEvent("video");
                        Tealium_1.default.video(__assign(__assign({}, lastEvent), { event_name: "player_stop", event_label: "stop", event_action: "stop" }));
                    }
                }
                _this.loadMediaSent = false;
            }
            _this.instance = window.jwplayer(playerId);
            if (!_this.instance) {
                _this.warn("No JwPlayer instance found!");
                return;
            }
            _this.subscribeToEvents();
        };
        /**
         * Basic logic to subscribe to events, calls subscribe from the extension to subscribe to the event
         */
        _this.subscribeToEvents = function () {
            var _a;
            _this.info("subscribe to events from jwplayer %c".concat((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.id, ":"), "font-weight:bold", "\n".concat(Object.keys(_this.events).join(", ")));
            _this.subscribedEvents = {};
            Object.keys(_this.events).forEach(function (eventKey) {
                _this.subscribedEvents[eventKey] = _this.eventWrapper(_this.events[eventKey]);
                _this.subscribe(eventKey, _this.subscribedEvents[eventKey]);
            });
        };
        /**
         * Basic logic to unsubscribe to events, calls unsubscribe from the extension to unsubscribe to the event
         */
        _this.unsubscribeToEvents = function () {
            var _a;
            _this.info("unsubscribe to events from jwplayer %c".concat((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.id, ":"), "font-weight:bold", "\n".concat(Object.keys(_this.subscribedEvents).join(", ")));
            Object.keys(_this.subscribedEvents).forEach(function (eventKey) {
                _this.unsubscribe(eventKey, _this.subscribedEvents[eventKey]);
                delete _this.subscribedEvents[eventKey];
            });
        };
        /**
         * Fires an event to Tealium (TAQ)
         */
        _this.eventWrapper = function (callback) { return function (event) {
            var _a;
            // Collect all the necessary data for the track event
            var collectCallbackData = callback(event);
            var eventType = event.type;
            // Check for custom event callbacks
            var clientCallbackData = {};
            if (((_a = _this.options) === null || _a === void 0 ? void 0 : _a.events) && typeof _this.options.events[eventType] === "function") {
                var callbackData = _this.options.events[eventType](event);
                if (callbackData === false) {
                    // Don't sent event
                    return;
                }
                clientCallbackData = callbackData;
            }
            // When we return false in a callback we will not fire the track event any more
            if (collectCallbackData === false) {
                return;
            }
            var trackData = _this.getTrackData();
            var event_action = collectCallbackData.event_action;
            var eventData = __assign(__assign(__assign(__assign({}, trackData), { event_name: "player_".concat(event_action) }), collectCallbackData), clientCallbackData);
            // When not in active Adobe Heartbeat session, we are using track type "link"
            if (_this.useAdobeDelay && !_this.loadMediaSent) {
                return Tealium_1.default.link(eventData);
            }
            Tealium_1.default.video(eventData);
        }; };
        _this.sendEvent = function (event) { return _this.eventWrapper(function () { return event; })({}); };
        _this.isLastEvent = function (action) { return EventLog_1.default.isLastEvent("player_".concat(action), constants_1.CallType.VIDEO); };
        _this.formatAdEvent = function (event, data) {
            return {
                event_action: data.event_action,
                event_category: "player",
                event_label: data.event_label,
                ad: 1,
                ad_id: event.id,
                ad_position: event.adposition + "-roll",
                ad_client: event.client,
                ad_podcount: event.podcount || 1,
                ad_sequence: event.sequence || 1,
                ad_breakcount: _this.state.ad.breakCount,
                ad_duration: event.duration ? round(event.duration) : 0,
            };
        };
        _this.getTrackData = function () {
            var _a, _b, _c;
            var jwData = {};
            if (_this.instance) {
                var playerConfig = void 0;
                var playerContainer = null;
                try {
                    playerConfig = _this.instance.getConfig() || {};
                    playerContainer = _this.instance.getContainer();
                }
                catch (error) {
                    playerConfig = {};
                }
                var playlistItem = void 0;
                try {
                    playlistItem = _this.instance.getPlaylistItem();
                }
                catch (error) {
                    // ignore this error when getPlaylistItem fails
                }
                var drmType = "";
                try {
                    var source = playlistItem.sources[0];
                    drmType = source.drm ? Object.keys(source.drm)[0] : "none";
                }
                catch (ignore) {
                    drmType = "none";
                }
                var adState = "";
                if (_this.state.ad.event) {
                    adState = _this.state.ad.paused ? "ad_paused" : "ad_playing";
                }
                var playerForm = "normal";
                if (playerConfig.isFloating || (playerContainer === null || playerContainer === void 0 ? void 0 : playerContainer.classList.contains("custom-floating")))
                    playerForm = "floating";
                if (playerConfig.pip)
                    playerForm = "picture_in_picture";
                var playerName = ((_b = (_a = _this.options) === null || _a === void 0 ? void 0 : _a.defaultLayer) === null || _b === void 0 ? void 0 : _b.player_name) || "";
                jwData = {
                    ad: 0,
                    c_player_position: _this.state.video.position || null,
                    media_drmtype: drmType,
                    media_encodingformat: playlistItem ? playlistItem.allSources[0].type : null,
                    media_offset: playerConfig.position || _this.state.video.position || playerConfig.starttime || 0,
                    media_playbackpercentage: playerConfig.playbackRate * 100,
                    media_playbackrate: playerConfig.playbackRate,
                    media_quality: _this.state.visualQuality ? "".concat(_this.state.visualQuality.level.height, "p") : "auto",
                    media_thumbnail: playlistItem ? playlistItem.image : null,
                    media_type: playerConfig.audioMode ? "audio" : "video",
                    player_id: "".concat(playerName, "_").concat(_this.instance.id),
                    player_autoplay: _this.playReason === "autostart",
                    player_casting: playerConfig.castActive || false,
                    player_fullscreen: playerConfig.fullscreen || false,
                    player_height: playerConfig.containerHeight || null,
                    player_source: playlistItem ? playlistItem.file : null,
                    player_state: adState || playerConfig.state || null,
                    player_engine: "html",
                    player_form: playerForm,
                    player_type: playerConfig.provider ? playerConfig.provider.name : null,
                    player_width: playerConfig.containerWidth || null,
                    event_category: "player",
                };
                var qoeFields = {};
                try {
                    var qoe = _this.instance.qoe();
                    qoeFields = {
                        media_bitrate: _this.state.visualQuality ? _this.state.visualQuality.level.bitrate : 0,
                        media_startup_time: (qoe === null || qoe === void 0 ? void 0 : qoe.firstFrame) ? round(qoe.firstFrame / 1000, 3) : 0,
                        // Todo: add fps	number	FPS value
                        // Todo: add droppedFrames	number	Number of dropped frames
                    };
                }
                catch (_d) { }
                jwData = __assign(__assign(__assign({}, playlistItem.metadata), jwData), qoeFields);
                if (!jwData.media_name) {
                    var metadata = playlistItem.metadata, type = playlistItem.type, seriesTitle = playlistItem.seriesTitle, title = playlistItem.title, seasonNumber = playlistItem.seasonNumber, tvSeasonEpisodeNumber = playlistItem.tvSeasonEpisodeNumber;
                    jwData.media_name =
                        type === "EPISODE" && seriesTitle
                            ? "".concat(seriesTitle, ", ").concat(seasonNumber, ", ").concat(tvSeasonEpisodeNumber)
                            : title || (metadata === null || metadata === void 0 ? void 0 : metadata.media_program_name);
                }
                // Make sure to keep correct metadata for live events
                if (playerConfig.streamType === "LIVE") {
                    jwData.c_media_playbacktype = "live";
                    jwData.media_duration = 0;
                }
            }
            if ((_c = _this.options) === null || _c === void 0 ? void 0 : _c.defaultLayer) {
                jwData = __assign(__assign({}, _this.options.defaultLayer), jwData);
            }
            (0, object_1.deleteNullValues)(jwData);
            return jwData;
        };
        _this.unsubscribe = function (off, func) {
            var _a;
            if (!_this.instance)
                return;
            if (off.includes(".")) {
                var _b = off.split("."), plugin = _b[0], event_1 = _b[1];
                (_a = _this.instance.getPlugin(plugin)) === null || _a === void 0 ? void 0 : _a.off(event_1, func);
            }
            else {
                _this.instance.off(off, func);
            }
        };
        _this.subscribe = function (on, func) {
            if (!_this.instance)
                return;
            if (on.includes(".")) {
                var _a = on.split("."), plugin = _a[0], event_2 = _a[1];
                var jwPlugin = _this.instance.getPlugin(plugin);
                if (jwPlugin) {
                    jwPlugin.on(event_2, func);
                }
            }
            else {
                _this.instance.on(on, func);
            }
        };
        /**
         * Default JW player events to subscribe to
         */
        _this.onAll = function (event) {
            switch (event) {
                case "buffer":
                case "bufferChange":
                case "time":
                case "userInactive":
                case "userActive":
                    break;
                default:
                    _this.log("warn", "Send[JW]", event);
            }
            return false;
        };
        _this.onPlaylist = function () {
            _this.state.video.volume = _this.instance.getConfig().volume;
            _this.state.ad.breakCount = 0;
            return {
                event_label: "loadplaylist",
                event_action: "loadplaylist",
            };
        };
        _this.onAdBreakStart = function () {
            var _a;
            _this.state.ad.breakCount++;
            _this.state.ad.event = null;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportAdBreakStarted(Conviva.Constants.AdType.CLIENT_SIDE, Conviva.Constants.AdPlayer.CONTENT);
            return false;
        };
        _this.onAdBreakEnd = function () {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportAdBreakEnded();
            return false;
        };
        _this.onAdStart = function (event) {
            return false;
        };
        _this.onAdTime = function (event) {
            var _a, _b, _c, _d;
            if (((_a = _this.state.ad.event) === null || _a === void 0 ? void 0 : _a.id) === event.id)
                _this.state.ad.position = event.position;
            if ((_this.state.ad.event && !_this.state.ad.paused) || ((_b = _this.instance) === null || _b === void 0 ? void 0 : _b.getState()) !== "playing") {
                return false;
            }
            if (_this.state.attemptPlay) {
                _this.state.attemptPlay = false;
                _this.sendEvent(_this.formatAdEvent(event, {
                    event_label: "ad_play",
                    event_action: "ad_play",
                }));
            }
            var eventAction = "ad_play";
            if (!_this.state.ad.event || event.id !== _this.state.ad.event.id) {
                _this.state.ad.event = event;
                eventAction = "ad_start";
                (_c = _this.conviva) === null || _c === void 0 ? void 0 : _c.reportAdStarted(_this.formatAdEvent(event, {
                    event_label: "ad_play",
                    event_action: "ad_play",
                }));
            }
            else if (_this.state.ad.paused) {
                eventAction = "ad_resume";
            }
            (_d = _this.conviva) === null || _d === void 0 ? void 0 : _d.reportAdMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.PLAYING);
            _this.state.ad.paused = false;
            return _this.formatAdEvent(event, {
                event_label: eventAction,
                event_action: eventAction,
            });
        };
        _this.onAdPlay = function (_event) {
            return false;
        };
        _this.onAdPause = function () {
            var _a;
            _this.playReason = "interaction";
            _this.state.ad.paused = true;
            _this.state.attemptPlay = true;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportAdMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.PAUSED);
            return _this.formatAdEvent(_this.state.ad.event, {
                event_label: "ad_pause",
                event_action: "ad_pause",
            });
        };
        _this.onAdError = function (event) {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportAdError(event.message, 1);
            _this.state.ad.event = null;
            _this.state.ad.position = 0;
            return false;
        };
        _this.onAdComplete = function () {
            var _a;
            var event = _this.state.ad.event;
            _this.state.ad.event = null;
            _this.state.ad.position = 0;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportAdEnded();
            return _this.formatAdEvent(event, {
                event_label: "ad_complete",
                event_action: "ad_complete",
            });
        };
        _this.onAdClick = function () {
            return _this.formatAdEvent(_this.state.ad.event, {
                event_label: "ad_click",
                event_action: "ad_click",
            });
        };
        _this.onBufferChange = function (event) {
            _this.state.video.bufferPercent = event.bufferPercent;
            return false;
        };
        _this.onLevelsChanged = function (event) {
            var level = event.levels[event.currentQuality];
            if (!level)
                return false;
            return {
                event_action: "quality_adjust",
                event_label: level.height ? "".concat(level.height, "p") : "auto",
            };
        };
        _this.onVisualQuality = function (visualQuality) {
            var _a;
            if (!visualQuality.level)
                return false;
            _this.state.visualQuality = visualQuality;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.BITRATE, visualQuality.level.bitrate);
            return false;
        };
        _this.onPlaylistItem = function () {
            _this.state.video.started = true;
            _this.state.video.position = 0;
            _this.state.video.bufferPercent = 0;
            _this.state.visualQuality = null;
            _this.loadMediaSent = false;
            return false;
        };
        _this.onBeforePlay = function (event) {
            var _a, _b, _c;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackRequested();
            if (event.playReason === "interaction")
                _this.state.attemptPlay = true;
            if (((_b = _this.instance) === null || _b === void 0 ? void 0 : _b.getState()) === "buffering") {
                (_c = _this.conviva) === null || _c === void 0 ? void 0 : _c.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.BUFFERING);
            }
            if (_this.useAdobeDelay) {
                return false;
            }
            if (_this.loadMediaSent)
                return false;
            // Used in case the load_media has not been send yet
            _this.loadMediaSent = true;
            return {
                event_label: "load_media",
                event_action: "load_media",
            };
        };
        _this.onPlay = function (event) {
            var _a;
            if (_this.isLastEvent("resume") || _this.state.video.scrubbing) {
                return false;
            }
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.PLAYING);
            if (!_this.loadMediaSent) {
                _this.loadMediaSent = true;
                _this.sendEvent({
                    event_label: "load_media",
                    event_action: "load_media",
                });
            }
            _this.state.completeSent = false;
            if (_this.state.attemptPlay) {
                _this.state.attemptPlay = false;
                _this.sendEvent({
                    event_label: "play",
                    event_action: "play",
                });
            }
            var eventAction = "resume";
            if (_this.state.video.started) {
                _this.state.video.started = false;
                eventAction = "start";
            }
            return {
                event_action: eventAction,
                event_label: eventAction,
            };
        };
        _this.onFirstFrame = function () {
            var _a;
            if (!_this.instance)
                return false;
            var track = _this.instance.getCaptionsList()[_this.instance.getCurrentCaptions()];
            var subtitleLabel = track.id === "off" ? "off" : "on";
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.SUBTITLES_LANGUAGE, subtitleLabel === "off" ? "" : "[nl]:".concat(track.label));
            return false;
        };
        _this.onTime = function (event) {
            _this.state.video.position = event.position;
            var utag = window.utag;
            if (utag && utag.media) {
                utag.media.video_current_playhead = event.position;
            }
            if (_this.isLastEvent("play")) {
                if (_this.state.video.started) {
                    _this.state.video.started = false;
                    return {
                        event_label: "start",
                        event_action: "start",
                    };
                }
                return {
                    event_label: "resume",
                    event_action: "resume",
                };
            }
            return false;
        };
        _this.onPause = function () {
            var _a;
            _this.playReason = "interaction";
            if (_this.isLastEvent("pause")) {
                return false;
            }
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.PAUSED);
            return {
                event_label: "pause",
                event_action: "pause",
            };
        };
        _this.onRemove = function () {
            var _a;
            if (_this.conviva) {
                _this.info("end conviva session");
                _this.conviva.reportPlaybackEnded();
                _this.conviva.cleanup();
                _this.conviva = null;
            }
            if (((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState()) !== "playing") {
                return false;
            }
            _this.sendEvent({
                event_label: "stop",
                event_action: "stop",
            });
            _this.state.video.position = 0;
            _this.state.ad.event = null;
            // Cleanup instance
            _this.instance = null;
            return false;
        };
        _this.onIdle = function (event) {
            if (_this.isLastEvent("stop") || _this.state.video.position === 0) {
                return false;
            }
            if (event.reason === "complete") {
                _this.state.completeSent = true;
                return {
                    event_action: "complete",
                };
            }
            var eventLabel = _this.state.video.position;
            _this.state.video.position = 0;
            return {
                event_label: eventLabel,
                event_action: "stop",
            };
        };
        _this.onComplete = function () {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackEnded();
            if (_this.isLastEvent("complete") || _this.state.completeSent) {
                return false;
            }
            _this.state.completeSent = true;
            return {
                event_action: "complete",
            };
        };
        _this.onSeek = function (event) {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.SEEK_STARTED, event.position);
            if (event.position - event.offset === 10 ||
                (parseInt(event.position, 10) < 10 && parseInt(event.offset, 10) === 0)) {
                return {
                    event_label: "rewind",
                    event_action: "rewind",
                };
            }
            _this.state.video.scrubbing = _this.instance.getConfig().scrubbing;
            if (_this.isLastEvent("pause") || _this.isLastEvent("play")) {
                return {
                    event_action: "seek",
                    event_label: event.position,
                    media_offset: event.position,
                };
            }
            return false;
        };
        _this.onSeeked = function () {
            var _a, _b, _c, _d, _e;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.SEEK_ENDED);
            if (((_b = _this.instance) === null || _b === void 0 ? void 0 : _b.getState()) === "buffering") {
                (_c = _this.conviva) === null || _c === void 0 ? void 0 : _c.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, ConvivaMonitor_1.PlayerStates.BUFFERING);
            }
            if (_this.state.video.scrubbing) {
                return false;
            }
            return {
                event_action: "seeked",
                event_label: (_d = _this.instance) === null || _d === void 0 ? void 0 : _d.getPosition(),
                media_offset: (_e = _this.instance) === null || _e === void 0 ? void 0 : _e.getPosition(),
            };
        };
        _this.onNextClick = function () {
            // Todo: add proper next event
            return _this.onComplete();
            // return {
            //   event_action: 'complete',
            // };
        };
        _this.onError = function (event) {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackError(event.message, 1);
            return {
                event_label: event.message,
                event_value: event.code,
                event_action: "error",
            };
        };
        _this.onWarning = function (event) {
            var _a;
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackError(event.message, 0);
        };
        _this.onAutostartNotAllowed = function () {
            _this.playReason = "interaction";
            _this.state.attemptPlay = true;
            return false;
        };
        _this.onFullscreen = function (event) {
            return {
                event_label: event.fullscreen,
                event_action: "fullscreen",
            };
        };
        _this.onMute = function (event) {
            var _a;
            var lastEvent = EventLog_1.default.getLastEvent();
            if (lastEvent &&
                event.mute === false &&
                lastEvent.event_name === "player_volume" &&
                lastEvent.event_label === "up") {
                return false;
            }
            var volume = event.mute ? 0 : ((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getVolume()) || 100;
            _this.state.video.volume = volume;
            return {
                event_value: volume,
                event_label: event.mute ? "mute" : "unmute",
                event_action: "volume",
            };
        };
        _this.onVolume = function (event) {
            var volumeState = event.volume > _this.state.video.volume ? "up" : "down";
            _this.state.video.volume = event.volume;
            return {
                event_value: event.volume,
                event_label: volumeState,
                event_action: "volume",
            };
        };
        _this.onPlaylistComplete = function () {
            _this.sendEvent({
                event_label: "stop",
                event_action: "stop",
            });
            _this.loadMediaSent = false;
            return false;
        };
        _this.onSharingClick = function (event) {
            return {
                event_value: event.method,
            };
        };
        _this.onCaptionsChanged = function (event) {
            var _a;
            var track = event.tracks[event.track];
            var subtitleLabel = track.id === "off" ? "off" : "on";
            (_a = _this.conviva) === null || _a === void 0 ? void 0 : _a.reportPlaybackMetric(Conviva.Constants.Playback.SUBTITLES_LANGUAGE, subtitleLabel === "off" ? "" : "[nl]:".concat(track.label));
            return {
                event_label: subtitleLabel,
                event_action: "subtitles",
            };
        };
        _this.onDisplayClick = function (event) {
            var _a;
            if (((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState()) === "complete") {
                return {
                    event_label: "replay",
                    event_action: "replay",
                };
            }
            return false;
        };
        _this.name = "JwMonitor";
        _this.events = {
            playlist: _this.onPlaylist,
            adBreakStart: _this.onAdBreakStart,
            adBreakEnd: _this.onAdBreakEnd,
            adStarted: _this.onAdStart,
            adTime: _this.onAdTime,
            adPlay: _this.onAdPlay,
            adPause: _this.onAdPause,
            adError: _this.onAdError,
            adComplete: _this.onAdComplete,
            adClick: _this.onAdClick,
            bufferChange: _this.onBufferChange,
            visualQuality: _this.onVisualQuality,
            playlistItem: _this.onPlaylistItem,
            beforePlay: _this.onBeforePlay,
            levelsChanged: _this.onLevelsChanged,
            play: _this.onPlay,
            firstFrame: _this.onFirstFrame,
            time: _this.onTime,
            pause: _this.onPause,
            idle: _this.onIdle,
            complete: _this.onComplete,
            seek: _this.onSeek,
            seeked: _this.onSeeked,
            nextClick: _this.onNextClick,
            error: _this.onError,
            warning: _this.onWarning,
            autostartNotAllowed: _this.onAutostartNotAllowed,
            fullscreen: _this.onFullscreen,
            mute: _this.onMute,
            volume: _this.onVolume,
            playlistComplete: _this.onPlaylistComplete,
            "sharing.click": _this.onSharingClick,
            captionsChanged: _this.onCaptionsChanged,
            displayClick: _this.onDisplayClick,
            remove: _this.onRemove,
        };
        return _this;
    }
    return JwMonitor;
}(Base_1.default));
exports.JwMonitor = JwMonitor;
exports.default = new JwMonitor();
